import { matchPath } from 'react-router';

import type { Route } from '@bugbug/core/types/routes';
import urls from '~/views/urls';

export const getAppRouteName = (pathname: string): Route | undefined =>
  Object.entries(urls)
    .filter(([, url]) => matchPath(pathname, { path: url })?.isExact)
    .at(-1)?.[0] as Route | undefined;
